import images from 'assets/images/images'
import useTranslate from 'hooks/useTranslate';
import {Trans} from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import {setUserChoises} from 'redux/features/general/generalSlice';
import { stages } from 'utils/Constants';
import { Link } from 'react-router-dom';
import Checkbox from 'components/form-elements/checkbox/Checkbox'
import { useState } from 'react'
import {toast} from 'react-toastify';
import {dataLayerPush} from 'utils/Datalayer'

const StageTypeSelection = ({ setRegisterState, isLogin }) => {
    const {t} = useTranslate()
    const {registerData} = useSelector(state => state.register)
    const [check,setCheck] = useState(false)
    const dispatch = useDispatch()
    const selectType = (type) => {
        if(type == "address"){
            dispatch(setUserChoises({deliveryType: 2, deliveryTab:2}))
            if(isLogin){
               setRegisterState(stages.STAGE_ADD_ADDRESS)
            }else{
               setRegisterState(stages.STAGE_ADDRESSES)
            }
        }else{
            dispatch(setUserChoises({deliveryType: 1, deliveryTab:1}))
            setRegisterState(stages.STAGE_CHOICE_BRANCH)
            //devamı buraya gelecek... 
        }
       
        //isLogin ? () => setRegisterState(stages.STAGE_ADD_ADDRESS) :  () => setRegisterState(stages.STAGE_ADDRESSES)
    }
    return (
        <div className="d-flex flex-column align-items-center">

            <div className="d-flex flex-column gap-3 text-center register-login">
                <h1 className="header-l">
                    {t('hello')} {registerData?.firstName}
                </h1>
                <div className="body-m">
                    {t('howReciveOrderQuestion')}
                </div>
            </div>

            <div className="d-flex align-items-center gap-4 mt-5">
                <div onClick={() => {
                    dataLayerPush({
                        event: "delivery_point",
                        delivery_name: "Adresime Gelsin",
                    })
                    
                    if(!check){
                        toast.error(t('etkAgreementText2Error'))
                    } else {
                        selectType("address")
                    }
                }}
                     className="card card-square bg-white cursor-pointer">
                    <img src={images.colorfulMotorcycle} alt="" />
                    <div className="header-m text-center">
                        {t('cometoMyAddress')}
                    </div>
                </div>
                <div onClick={() => {
                    dataLayerPush({
                        event: "delivery_point",
                        delivery_name: "Şubeden Almak İstiyorum",
                    })
                    
                    if(!check){
                        toast.error(t('etkAgreementText2Error'))
                    } else {
                        selectType("branch")
                    }
                }}
                    className="card card-square bg-white cursor-pointer">
                    <img src={images.location} alt="" />
                    
                        
                    <div className="header-m text-center">
                    <Trans
                        i18nKey='wantToBuyFromBranch'
                        components={{ break: <br /> }}
                    />
                    </div>
                </div>
            </div>
            <span className='mt-4'><Trans 
                    i18nKey='loginWithoutRegisterAgreementText'
                    values={{ linkText: t('fromHere') }}
                    components={{
                        triggerBtn: <Link style={{fontFamily: 'BatonWeb-Bold'}} target='_blank' to='/sayfa/uye-olmadan-satin-alma-aydinlatma-metni' />
                    }}
                /></span>
            <span className='mt-4'><Trans 
                i18nKey='userAgreementContinueText2'
                values={{ linkText: t('here') }}
                components={{
                    triggerBtn: <Link style={{fontFamily: 'BatonWeb-Bold'}} target='_blank' to='/sayfa/ticari-elektronik-aydinlatma-metni' />
                }}
            /></span>
            <Checkbox
				className={'checkboxLongTextClassName checkbox-orange mt-4'}
				id={"fourcheck"} 
                isLabelSpan={true}
				textLabel={<span><Trans 
                    i18nKey='etkAgreementText2'
                    values={{ linkText: t('commercialElectronicMessages') }}
                    components={{
                        triggerBtn: <Link style={{fontFamily: 'BatonWeb-Bold'}} target='_blank' to='/sayfa/etk-izin-metni' />
                    }}
                /></span>}
				checked={check}
				onChange={(e) => setCheck(e.target.checked)}
			/>
        </div>
    )
}

export default StageTypeSelection